import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "b2r_cookie_notice_v1";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(!localStorage.getItem(KEY)); }, []);
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, new Date().toISOString()); setShow(false); };
  return (
    <div role="region" aria-label="Cookie notice" className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 rise" data-testid="cookie-banner">
      <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-5">
        <div className="flex gap-3">
          <Cookie className="h-5 w-5 text-teal-700 shrink-0 mt-0.5" aria-hidden />
          <div className="text-sm text-slate-700 space-y-3">
            <p>We use <strong>essential cookies only</strong>: one to keep you signed in, plus those Stripe sets during checkout for fraud prevention. No advertising or tracking cookies.</p>
            <div className="flex items-center gap-3">
              <Button size="sm" className="rounded-full" onClick={close} data-testid="cookie-accept-button">Got it</Button>
              <Link to="/legal/cookies" className="text-teal-800 underline underline-offset-4" data-testid="cookie-policy-link">Cookie policy</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
